import clsx from "clsx";
import RadioInput from "../RadioInput/RadioInput";

export type RadioType = {
  onChange: (selected: string | number | boolean) => void;
  selected: string | number | boolean;
  disabled?: boolean;
  options: Array<any>;
  columns?: number;
};

const RadioGroup: React.FC<RadioType> = ({
  disabled = false,
  options,
  selected,
  onChange,
  columns = 1,
}) => {
  return (
    <div
      className={clsx([
        "grid",
        "gap-2",
        "w-full",
        `grid-cols-${columns}`,
        {
          "pointer-events-none": disabled,
          // "flex-row items-center": layout === "horizontal",
        },
      ])}
    >
      {options?.map?.(({ label, description, value }) => {
        return (
          <RadioInput
            label={label}
            description={description}
            selected={value === selected}
            value={value}
            key={value}
            onClick={() => onChange(value)}
          />
        );
      })}
    </div>
  );
};

export default RadioGroup;
